import { render, staticRenderFns } from "./BuyerChannelBidding.vue?vue&type=template&id=0a241612&scoped=true"
import script from "./BuyerChannelBidding.vue?vue&type=script&lang=js"
export * from "./BuyerChannelBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a241612",
  null
  
)

export default component.exports